"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RichTextViewer.css");
// import Deps from '../__exports';
// import { IconNameType } from '../__exports.types';
var sanitize = require("sanitize-html");
/**
 * @see RichTextViewerProps
 */
var RichTextViewer = /** @class */ (function (_super) {
    __extends(RichTextViewer, _super);
    function RichTextViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.createMarkup = _this.createMarkup.bind(_this);
        return _this;
    }
    RichTextViewer.prototype.componentDidMount = function () {
        this.props.allowScripts && this.appendScriptToBody(this.props.html);
    };
    RichTextViewer.prototype.appendScriptToBody = function (html) {
        var scriptElement = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
        var scriptOpeningTag = /<script\b[^>]*([\s\S]*?)>/gm;
        var match;
        var _loop_1 = function () {
            var script = document.createElement('script');
            var scriptAttrs = (scriptOpeningTag.exec(match[0]) || [])[0];
            scriptAttrs &&
                scriptAttrs.split(' ').forEach(function (a) {
                    var _a = a.split('='), attribute = _a[0], value = _a[1];
                    if (attribute && value) {
                        script[attribute] = value.split('"')[1];
                    }
                });
            script.innerHTML = match[1];
            document.body.appendChild(script);
        };
        while ((match = scriptElement.exec(html))) {
            _loop_1();
        }
    };
    RichTextViewer.prototype.createMarkup = function () {
        var _filter = {};
        _filter['allowedTags'] = this.props.allowedTags;
        _filter['allowedAttributes'] = this.props.allowedAttributes;
        _filter['allowedClasses'] = this.props.allowedClasses;
        _filter['allowedSchemes'] = this.props.allowedSchemes;
        return { __html: sanitize(this.props.html || '', _filter) };
    };
    RichTextViewer.prototype.render = function () {
        return (React.createElement("div", { id: this.props.id, className: "p-htmlviewer", "data-tag": this.props.tag, dangerouslySetInnerHTML: this.createMarkup() }));
    };
    RichTextViewer.defaultProps = {
        id: '',
        tag: '',
        html: '',
        allowedTags: [
            'a',
            'abbr',
            'acronym',
            'address',
            'area',
            'article',
            'aside',
            'b',
            'bdi',
            'big',
            'blockquote',
            'body',
            'br',
            'button',
            'caption',
            'center',
            'cite',
            'code',
            'col',
            'colgroup',
            'data',
            'datalist',
            'dd',
            'del',
            'details',
            'dfn',
            'dir',
            'div',
            'dl',
            'dt',
            'em',
            'fieldset',
            'figcaption',
            'figure',
            'font',
            'footer',
            'form',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'head',
            'header',
            'hr',
            'html',
            'i',
            'img',
            'input',
            'ins',
            'kbd',
            'keygen',
            'label',
            'legend',
            'li',
            'main',
            'map',
            'mark',
            'menu',
            'menuitem',
            'meter',
            'nav',
            'ol',
            'optgroup',
            'option',
            'output',
            'p',
            'pre',
            'progress',
            'q',
            'rp',
            'rt',
            'ruby',
            's',
            'samp',
            'section',
            'select',
            'small',
            'span',
            'strike',
            'strong',
            'sub',
            'summary',
            'sup',
            'table',
            'tbody',
            'td',
            'textarea',
            'tfoot',
            'th',
            'thead',
            'time',
            'tr',
            'tt',
            'u',
            'ul',
            'var',
            'wbr'
        ],
        allowedAttributes: {
            '*': [
                'abbr',
                'accept',
                'accept-charset',
                'accesskey',
                'action',
                'align',
                'alt',
                'autocomplete',
                'autosave',
                'axis',
                'bgcolor',
                'border',
                'cellpadding',
                'cellspacing',
                'challenge',
                'char',
                'charoff',
                'charset',
                'checked',
                'cite',
                'clear',
                'color',
                'cols',
                'colspan',
                'compact',
                'contenteditable',
                'coords',
                'datetime',
                'dir',
                'disabled',
                'draggable',
                'dropzone',
                'enctype',
                'for',
                'frame',
                'headers',
                'height',
                'high',
                'href',
                'hreflang',
                'hspace',
                'id',
                'ismap',
                'keytype',
                'label',
                'lang',
                'list',
                'longdesc',
                'low',
                'max',
                'maxlength',
                'media',
                'method',
                'min',
                'multiple',
                'name',
                'nohref',
                'noshade',
                'novalidate',
                'nowrap',
                'open',
                'optimum',
                'pattern',
                'placeholder',
                'prompt',
                'pubdate',
                'radiogroup',
                'readonly',
                'rel',
                'required',
                'rev',
                'reversed',
                'rows',
                'rowspan',
                'rules',
                'scope',
                'selected',
                'share',
                'size',
                'span',
                'spellcheck',
                'src',
                'start',
                'step',
                'style',
                'summary',
                'tabindex',
                'target',
                'title',
                'type',
                'usemap',
                'valign',
                'value',
                'vspace',
                'width',
                'wrap',
                'data-*',
                'background',
                'dynsrc',
                'lowsrc',
                {
                    name: 'class',
                    multiple: true,
                    values: [
                        'background',
                        'background-attachment',
                        'background-color',
                        'background-image',
                        'background-position',
                        'background-repeat',
                        'border',
                        'border-bottom',
                        'border-bottom-color',
                        'border-bottom-style',
                        'border-bottom-width',
                        'border-collapse',
                        'border-color',
                        'border-left',
                        'border-left-color',
                        'border-left-style',
                        'border-left-width',
                        'border-right',
                        'border-right-color',
                        'border-right-style',
                        'border-right-width',
                        'border-spacing',
                        'border-style',
                        'border-top',
                        'border-top-color',
                        'border-top-style',
                        'border-top-width',
                        'border-width',
                        'bottom',
                        'caption-side',
                        'clear',
                        'clip',
                        'color',
                        'content',
                        'counter-increment',
                        'counter-reset',
                        'cursor',
                        'direction',
                        'display',
                        'empty-cells',
                        'float',
                        'font',
                        'font-family',
                        'font-size',
                        'font-style',
                        'font-variant',
                        'font-weight',
                        'height',
                        'left',
                        'letter-spacing',
                        'line-height',
                        'list-style',
                        'list-style-image',
                        'list-style-position',
                        'list-style-type',
                        'margin',
                        'margin-bottom',
                        'margin-left',
                        'margin-right',
                        'margin-top',
                        'max-height',
                        'max-width',
                        'min-height',
                        'min-width',
                        'opacity',
                        'orphans',
                        'outline',
                        'outline-color',
                        'outline-style',
                        'outline-width',
                        'overflow',
                        'padding',
                        'padding-bottom',
                        'padding-left',
                        'padding-right',
                        'padding-top',
                        'page-break-after',
                        'page-break-before',
                        'page-break-inside',
                        'quotes',
                        'right',
                        'table-layout',
                        'text-align',
                        'text-decoration',
                        'text-indent',
                        'text-transform',
                        'top',
                        'unicode-bidi',
                        'vertical-align',
                        'visibility',
                        'white-space',
                        'widows',
                        'width',
                        'word-spacing',
                        'z-index'
                    ]
                }
            ]
        },
        allowedClasses: {
            '*': ['*']
        },
        allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel'],
        allowScripts: false
    };
    return RichTextViewer;
}(React.Component));
exports.default = RichTextViewer;
//# sourceMappingURL=RichTextViewer.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/rich-text-viewer/build/control/RichTextViewer.js
// module id = 610
// module chunks = 0